import React, { Component } from "react";
import { trackPromise } from 'react-promise-tracker';
import PagoServicioService from "../../../services/pagoServicios/pagoServicioService";

import InputText from "./InputText";
import OptionInput from "./OptionInput";
import DateInput from "../../../components/generico/CampoFecha";
import MensajeLogin from '../../generico/Login/MensajeLogin';
import Popup from "react-popup";
import $ from "jquery";
import PronetTitulo from "./PronetTitulo"
import CabeceraWizard from "./CabeceraWizard"
import history from "../login/history";
import { splitImporte, agregarBarra, reemplazarBarra } from "../../generico/utils/FormatoInput";
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";
import { MENSAJE } from "../../generico/utils/Constantes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";


export default class PronetPaso1 extends Component {
  ambosDesactivados = false;
  constructor(props) {
    super(props);
    this.handleOK = this.handleOK.bind(this);
    this.validatePago = this.validatePago.bind(this);
    this.state = {
      codigo: props.codigo,
      formulario: undefined,
      formularioConsulta: undefined,
      tipoTrx: "",
      campos: [],
      camposRespuesta: [],
      validaciones: [],
      respuestaPaso1: props.respuestaPaso1,
      msgError: "",
      disableSgte: true

    };

    if (props.codigo === "55") {
      Popup.queue(this.notifiPopup("ATENCIÓN", MENSAJE.TEXTO_SET));
    }


  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  componentDidMount() {

    sessionStorage.removeItem("servicio")
    sessionStorage.removeItem("nombre")
    sessionStorage.removeItem("img")
    sessionStorage.removeItem("entidad")
    this.obtenerFormulario();
    $('#btn-pago').attr('disabled', 'true');
    $('#btn-next').attr('disabled', 'true');
  }


  obtenerFormulario() {

    trackPromise(
      PagoServicioService.getCamposFormulario(this.props.codigo)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);

          if (jsonData.codRetorno === "0") {
            var camposRespuesta = jsonData.campo;
            var tipo = jsonData.tipoTrx;
            var camposObt = [];
            var validar = []
            for (var i = 0; i < camposRespuesta.length; i++) {
              var datos = JSON.parse(JSON.stringify(camposRespuesta[i]));
              camposObt[i] = datos
              validar.push({
                name: datos.name,
                required: datos.required,
                minLength: datos.minLength,
                maxLenght: datos.maxLenght,
                value: datos.value
              })
            }
            // console.log(JSON.stringify(camposObt))
            this.setState({ formulario: jsonData, campos: camposObt, tipoTrx: tipo, msgError: "", validaciones: validar });

          }
          else {
            var resMessage = jsonData.desRetorno;
            Popup.queue(this.notifiPopup("Info", resMessage));
            return;


          }
        }
        ));

  }

  handleOK(e) {
  }

  buscarDuplicados = (nombre, valor) => {
    var aux = this.state.camposRespuesta
    var optionsAux = []
    for (var i = 0; i < aux.length; i++) {
      if (aux[i].name === nombre && aux[i].value === valor) {
        optionsAux.push({
          name:
            nombre,
          value: valor

        })
        return optionsAux;
      }
      if (aux[i].name === nombre && aux[i].value !== valor) {
        optionsAux.push({
          name:
            nombre,
          value: valor

        })
        return optionsAux;
      }
    }


  }

  inputValue = (dataFromChild, nombre, error, descripcionError, tipo, label, requerido, min) => {
    //console.log("valores recibidos " + dataFromChild + " " + nombre + " " + error + " " + descripcionError + " " + tipo + " " + requerido + " " + min)
    var options = this.state.camposRespuesta
    var optForm = this.state.campos


    if (error) {
      this.setState({ msgError: descripcionError, disableSgte: true });
      return
    }

    if (dataFromChild !== "") {
      var datoChild = dataFromChild
      if (tipo === "MONEY")
        datoChild = splitImporte(dataFromChild)
      if (tipo === "DATE")
        datoChild = reemplazarBarra(dataFromChild)
      var esNuevo = true
      for (var i = 0; i < options.length; i++) {
        if (options[i].name === nombre) {
          esNuevo = false;
          options.splice(i, 1)

          options.push({
            label:
              label,
            name:
              nombre,
            value: datoChild

          })


        }
      }
      if (esNuevo) {
        options.push({
          label:
            label,
          name:
            nombre,
          value: datoChild

        })

      }
      for (var i = 0; i < optForm.length; i++) {
        if (optForm[i].name === nombre) {
          optForm[i].value = datoChild


        }
      }
      var cantRequeridos = 0;
      var cantCargados = 0;

      for (var f = 0; f < optForm.length; f++) {
        if (optForm[f].required === "true") {
          cantRequeridos = cantRequeridos + 1;
          for (var o = 0; o < options.length; o++) {
            if (optForm[f].name === options[o].name) {
              cantCargados = cantCargados + 1;
            }
          }

        } else {
          for (var o = 0; o < options.length; o++) {
            if (optForm[f].name === options[o].name) {
              cantCargados = cantCargados + 1;
            }
          }
        }
      }
      /*  console.log("cantidad de requeridos " + cantRequeridos)
        console.log("cantidad de cargados " + cantCargados)*/
      if (cantCargados > 0 && cantRequeridos === cantCargados) {
        // console.log("DESBLOQUEAR")
        if ($('#btn-pago').is(':disabled')) {
          $('#btn-pago').removeAttr('disabled');
        }
        if ($('#btn-next').is(':disabled')) {
          $('#btn-next').removeAttr('disabled');
        }
      } else {
        if (cantCargados > 0 && cantRequeridos === 0) {
          if ($('#btn-pago').is(':disabled')) {
            $('#btn-pago').removeAttr('disabled');
          }
          if ($('#btn-next').is(':disabled')) {
            $('#btn-next').removeAttr('disabled');
          }

        } else {
          if (cantCargados < cantRequeridos) {
            $('#btn-pago').attr('disabled', 'true');
            $('#btn-next').attr('disabled', 'true');
          }
        }

      }

      this.setState({ camposRespuesta: options, campos: optForm });

    }

  };


  validatePagar = (elemento) => {

    $.validator.setDefaults({
      submitHandler: () => {

        this.validatePago();
      }
    });
    $("#idPronetPaso1").submit(function (e) {

      e.preventDefault();

    }).validate({

      errorElement: "span",
      showErrors: function (errorMap, errorList) {
        $(".is-invalid").each(function () {
          this.classList.remove("is-invalid");
        });
        if (errorList[0] != null) {

          errorList[0].element.classList.add("is-invalid")
          var errorActual = errorList[0].message
          if (errorList[0].method === "required")
            errorActual = "Campo Requerido"
          if (errorList[0].method === "minlength")
            errorActual = "Por favor, ingrese al menos de " + errorList[0].element.minLength + " caracteres"
          if (errorList[0].method === "maxlength")
            errorActual = "El tamaño máximo es de " + errorList[0].element.maxLength + " caracteres"

          $(".form-validate").html(errorActual);
          $('#btn-pago').attr('disabled', 'true');
        }

      }

    });

  };



  validateContinuar = () => {
    this.verificarEntrustyOtp();
    $.validator.setDefaults({
      submitHandler: () => {
        this.validateSeguir();
      }
    });
    $("#idPronetPaso1").submit(function (e) {

      e.preventDefault();
    }).validate({

      errorElement: "span",
      showErrors: function (errorList) {
        $(".is-invalid").each(function () {
          this.classList.remove("is-invalid");
        });

        if (errorList[0] != null) {
          errorList[0].element.classList.add("is-invalid")
          var errorActual = errorList[0].message
          if (errorList[0].method === "required")
            errorActual = "Campo Requerido"
          if (errorList[0].method === "minlength")
            errorActual = "Por favor, ingrese al menos de " + errorList[0].element.minLength + " caracteres"
          if (errorList[0].method === "maxlength")
            errorActual = "El tamaño máximo es de " + errorList[0].element.maxLength + " caracteres"
          $(".form-validate").html(errorActual);
          $('#btn-next').attr('disabled', 'true');
        }
      }
    });

  };

  verificarTipo(elemento) {

    if (elemento.type === "OPTION") {
      if (elemento.required === "true") {
        return (<OptionInput label={elemento.label} name={elemento.name}
          required={elemento.required} options={elemento.options} title={elemento.title}
          editable={elemento.editable} hidden={elemento.hidden}
          inputValue={this.inputValue.bind(this)} value={elemento.value}
        />);
      } else {
        return (<OptionInput label={elemento.label} name={elemento.name}
          options={elemento.options} title={elemento.title}
          editable={elemento.editable} hidden={elemento.hidden}
          inputValue={this.inputValue.bind(this)} value={elemento.value}
        />);
      }
    }
    if (elemento.format === "DATE") {
      if (elemento.required === "true") {
        return (<DateInput name={elemento.name} size={elemento.size} title={elemento.title} hidden={elemento.hidden}
          editable={elemento.editable} type={elemento.type} label={elemento.label} minValue={elemento.minValue}
          maxValue={elemento.maxValue} minLength={elemento.minLength} maxLength={elemento.maxLenght} format={elemento.format}
          required={elemento.required} nullable={elemento.nullable} debitable={elemento.debitable} value={agregarBarra(elemento.value)}
          inputValue={this.inputValue.bind(this)}
        />);
      } else {
        return (<DateInput name={elemento.name} size={elemento.size} title={elemento.title} hidden={elemento.hidden}
          editable={elemento.editable} type={elemento.type} label={elemento.label} minValue={elemento.minValue}
          maxValue={elemento.maxValue} minLength={elemento.minLength} maxLength={elemento.maxLenght} format={elemento.format}
          nullable={elemento.nullable} debitable={elemento.debitable} value={agregarBarra(elemento.value)}
          inputValue={this.inputValue.bind(this)}
        />);
      }
    }
    else {
      if (elemento.required === "true") {
        return (<InputText name={elemento.name} size={elemento.size} title={elemento.title} hidden={elemento.hidden}
          editable={elemento.editable} type={elemento.type} label={elemento.label} minValue={elemento.minValue}
          maxValue={elemento.maxValue} minLength={elemento.minLength} maxLength={elemento.maxLenght} format={elemento.format}
          required={elemento.required} nullable={elemento.nullable} debitable={elemento.debitable}
          inputValue={this.inputValue.bind(this)} value={elemento.value}
        />);
      } else {
        return (<InputText name={elemento.name} size={elemento.size} title={elemento.title} hidden={elemento.hidden}
          editable={elemento.editable} type={elemento.type} label={elemento.label} minValue={elemento.minValue}
          maxValue={elemento.maxValue} minLength={elemento.minLength} maxLength={elemento.maxLenght} format={elemento.format}
          nullable={elemento.nullable} debitable={elemento.debitable}
          inputValue={this.inputValue.bind(this)} value={elemento.value}
        />);
      }
    }
  }

  validateSeguir = (e) => {
    this.props.respuestaPaso1(JSON.parse(JSON.stringify(this.state.camposRespuesta)), "SI", this.state.tipoTrx);
    //  console.log("FORMULARIO INGRESADO " + JSON.stringify(this.state.campos))
    this.nextStep.click();

  };



  validatePago() {
    this.props.respuestaPaso1(JSON.parse(JSON.stringify(this.state.campos)), "SI", this.state.tipoTrx, this.state.campos);
    //    console.log("FORMULARIO INGRESADO " + JSON.stringify(this.state.campos))
    this.setState({ msgError: "" });
    this.lastStep.click();

  };


  volver = (e) => {

    //history.push('/PagoServicio');
    history.push(ConfigService.getPathByName("pagoServicio")?.url);
    window.location.reload();
  }

  handleEnter(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  }

  verificarEntrustyOtp = () =>{
    // this.props.verificacionEntrustOtp();
    // console.log('muestraPantallaEntrust: '+this.props.muestraPantallaEntrust);
    // console.log('muestraPantallaOtpSms: '+this.props.muestraPantallaOtpSms);
    // return !this.props.muestraPantallaEntrust && !this.props.muestraPantallaOtpSms ? 
    // {display:"none"} : null;
    !this.props.muestraPantallaEntrust && !this.props.muestraPantallaOtpSms ? 
    this.ambosDesactivados = true : this.ambosDesactivados = false;
  }

  render() {
    if (this.props.currentStep !== 1) { // Prop: The current step
      return null
    }
    var campo = []
    // console.log("RECIBE PARA MOSTRAR "+JSON.stringify(this.props.formulario))
    if (this.props.formulario === undefined)
      campo = this.state.campos
    else
      campo = this.props.formulario

    // console.log("VA A MOSTRAR "+JSON.stringify(campo))
    return (

      <div>
        {/******************* CABECERA WIZARD ***********************/}
        
        <div className="row">
          <CabeceraWizard
            nombre={this.props.nombre}
            tittle1="current"
            tittle2="disabled"
            tittle3="disabled"
            tittle4="disabled"
            tittle5="disabled"
            tittle6="disabled"
          />
        </div>
        
        <PronetTitulo img={this.props.img} empresa={this.props.empresa} />
        <hr />
        <div className="row justify-content-md-center">
          <div className="col-md-6">
            <div className="form-validate"></div>
          </div>
        </div>


        <form id="idPronetPaso1" onKeyDown={this.handleEnter}>
          {/******************* LOGICA PASOS ***********************/}
          <div className="row justify-content-md-center">
            <div className="col-md-6">

              {campo.map(elemento =>
                this.verificarTipo(elemento)
              )
              }

            </div>
            {this.state.msgError && (<MensajeLogin
              tipo="ERROR"
              mensaje={this.state.msgError} />

            )}

          </div>
          <hr />
          <div className="row">
            <div className="col-lg-8 col-md-6"></div>
            <div className="col-lg-2 col-md-3 btn-consulta">
            <button className="btn btn-cu-quintary" onClick={this.volver}>
            <FontAwesomeIcon icon={faArrowLeft} />  Volver</button>
            </div>
            <div className="col-lg-2 col-md-3">
            {this.state.tipoTrx == "CONSULTA" ?
              <button id="btn-next"

                className="btn btn-cu-primary" onClick={() => {this.validateContinuar()}}>Continuar <FontAwesomeIcon icon={faArrowRight} /></button>
              : <button id="btn-pago"

                className="btn btn-cu-primary" onClick={()=>{this.validatePagar();console.log('Pago')}} >Continuar <FontAwesomeIcon icon={faArrowRight} /> </button>
            }

            </div>
          </div>
         
          <button
            hidden
            ref={(a) => (this.nextStep = a)}
            className="btn btn-cu-primary"
            onClick={this.props.nextStep}
          ></button>

          <button
            hidden
            ref={(a) => (this.lastStep = a)}
            className="btn btn-cu-primary"
            onClick={() => this.props.goToStep(3)}

          ></button>


        </form>
      </div>

    );
  }
}